import { SCOUT_CRITERIA_DEFAULTS } from "../models";
import { llmApiPost } from "./llmApiClient";

const asString = (v) => (typeof v === "string" && v.trim() ? v.trim() : null);
const asStringArray = (v) => {
  if (!Array.isArray(v)) return null;
  const clean = v.map((x) => asString(x)).filter(Boolean);
  return clean.length > 0 ? clean : null;
};
const asInt = (v) => {
  if (v === null || v === undefined || v === "") return null;
  const n = parseInt(v, 10);
  return Number.isFinite(n) ? n : null;
};
const asBool = (v) => {
  if (typeof v === "boolean") return v;
  if (v === "true") return true;
  if (v === "false") return false;
  return null;
};

const coerceCriteria = (parsed) => {
  if (!parsed || typeof parsed !== "object") return null;
  return {
    ...SCOUT_CRITERIA_DEFAULTS,
    sport: asString(parsed.sport),
    positions: asStringArray(parsed.positions),
    age_min: asInt(parsed.age_min),
    age_max: asInt(parsed.age_max),
    competition_level_min: asString(parsed.competition_level_min),
    regions: asStringArray(parsed.regions),
    scholarship_offered: asBool(parsed.scholarship_offered),
    key_traits: asStringArray(parsed.key_traits),
    // Derived by the backend from the labels above, not by the model. This
    // whitelist is what gets persisted to scout_searches.criteria, so omitting
    // them here would silently drop every search back to label-only scoring.
    position_codes: asStringArray(parsed.position_codes),
    position_groups: asStringArray(parsed.position_groups),
    tag_codes: asStringArray(parsed.tag_codes),
  };
};

const coerceTitle = (raw, fallbackBrief) => {
  const cleaned = asString(raw);
  if (cleaned) return cleaned.slice(0, 80);
  const words = (fallbackBrief || "").trim().split(/\s+/).slice(0, 6).join(" ");
  return words || "Búsqueda sin título";
};

export const extractScoutCriteria = async (brief) => {
  const trimmed = (brief || "").trim();
  if (!trimmed) return null;

  const data = await llmApiPost("/v1/scout-criteria", { brief: trimmed });

  const criteria = coerceCriteria(data?.criteria);
  if (!criteria) {
    throw new Error("La extracción no produjo criterios válidos.");
  }
  return { title: coerceTitle(data?.title, trimmed), criteria };
};

const COMP_LEVEL_LABELS = {
  Recreativo: "Recreativo o superior",
  Amateur: "Amateur o superior",
  "Semi-Profesional": "Semi-Profesional o superior",
  Profesional: "Profesional o superior",
  Élite: "Élite",
};

export const summarizeCriteria = (criteria) => {
  if (!criteria) return null;
  const parts = [];
  if (criteria.sport) parts.push(`Deporte: ${criteria.sport}`);
  if (criteria.positions?.length)
    parts.push(`Posiciones: ${criteria.positions.join(", ")}`);
  if (criteria.age_min != null || criteria.age_max != null) {
    const min = criteria.age_min ?? "?";
    const max = criteria.age_max ?? "?";
    parts.push(`Edad: ${min}–${max}`);
  }
  if (criteria.competition_level_min)
    parts.push(
      COMP_LEVEL_LABELS[criteria.competition_level_min] ||
        criteria.competition_level_min,
    );
  if (criteria.regions?.length)
    parts.push(`Regiones: ${criteria.regions.join(", ")}`);
  if (criteria.key_traits?.length)
    parts.push(`Atributos: ${criteria.key_traits.join(", ")}`);
  if (criteria.scholarship_offered) parts.push("Ofrece beca");
  return parts.length ? parts.join(" · ") : null;
};
